'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { omitProps } from 'UIComponents/utils/Props';
import { OLAF, SLINKY } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import MediaBar from '../../../components/endpoint/MediaBar';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLink = styled(omitProps(UILink, ['isActive'])).withConfig({
  displayName: "LanguagePicker__StyledLink",
  componentId: "sc-5zkg83-0"
})(["padding:0 8px;color:", ";"], props => props.isActive ? OLAF : SLINKY);
const getLanguageKey = language => {
  language = language.replace(/^(.*)\//, '').replace('.', '_');
  if (language === '*/*' || language === '*') {
    return 'all';
  }
  return language;
};
const LanguagePicker = ({
  languages,
  onCopyValue,
  selectedLanguage,
  setLanguage,
  value
}) => {
  const selectedLanguageKey = getLanguageKey(selectedLanguage);
  return /*#__PURE__*/_jsx(MediaBar, {
    value: value,
    onClick: onCopyValue,
    children: /*#__PURE__*/_jsx(UIList, {
      inline: true,
      children: languages.map(language => {
        const languageKey = getLanguageKey(language);
        const isActive = languageKey === selectedLanguageKey;
        return /*#__PURE__*/_jsx(StyledLink, {
          isActive: isActive,
          onClick: () => {
            setLanguage(languageKey);
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.languages.${languageKey}`,
            options: {
              defaultValue: languageKey
            }
          })
        }, languageKey);
      })
    })
  });
};
LanguagePicker.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCopyValue: PropTypes.func,
  selectedLanguage: PropTypes.string.isRequired,
  setLanguage: PropTypes.func.isRequired,
  value: PropTypes.string
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
LanguagePicker.defaultProps = {
  onCopyValue: () => {}
};
export default LanguagePicker;